module.exports = __webpack_public_path__ + "toBride2-we-g-b.9958b2b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-g-b.jpg
// module id = /4Va
// module chunks = 0